import {
        createBrowserRouter,
        Route,
        createRoutesFromElements,
        RouterProvider,
        Navigate
      } from "react-router-dom"


//pages
import Home from "./pages/Home"
import AboutNAS from "./pages/AboutNAS"
import Bios from "./pages/Bios"
import PeerBefriending from "./pages/PeerBefriending"
import AdaptiveGrowth from "./pages/AdaptiveGrowth"
import AdditionalReading from "./pages/AdditionalReading"
import ResourcesHub from "./pages/ResourcesHub"
import About from "./pages/About"
import Community from "./pages/Community"
import Resources from "./pages/Resources"
import Contact from "./pages/Contact"

//layouts
import RootLayout from "./layouts/RootLayout"


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />

      {/* About NAS */}
      <Route path="about" element={<AboutNAS />} />
      <Route path="about/team" element={<Bios />} />

      {/* Peer Befriending */}
      <Route path="peer-befriending" element={<PeerBefriending />} />

      {/* Adaptive Growth Culture */}
      <Route path="adaptive-growth-culture" element={<AdaptiveGrowth />} />
      <Route path="adaptive-growth-culture/reading" element={<AdditionalReading />} />

      {/* Resources */}
      <Route path="resources" element={<ResourcesHub />} />
      <Route path="resources/what-is-aphasia" element={<About />} />
      <Route path="resources/newsletter" element={<Community />} />
      <Route path="resources/community" element={<Resources />} />

      {/* Contact */}
      <Route path="contact" element={<Contact />} />

      {/* Old URLs → new pages */}
      <Route path="bios" element={<Navigate to="/about/team" replace />} />
      <Route path="team" element={<Navigate to="/about/team" replace />} />
      <Route path="community" element={<Navigate to="/resources/newsletter" replace />} />
      <Route path="highlight" element={<Navigate to="/resources/community" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  ))




function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
